// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';

import List from '../../components/PlasmaScreens/List';
import DeletePlasmaPropertyModal from '../../components/PlasmaScreens/DeletePlasmaPropertyModal';
import AddPlasmaPropertyModal from '../../components/PlasmaScreens/AddPlasmaPropertyModal';
import Pagination from '../../components/shared/Pagination';

import Loader from '../../components/Loader/Loader';

import {
    loadPlasmaScreensProperties,
    addPromptReset,
    showAddPropertyToPlasmaScreenPrompt,
    addPromptEnteredReferenceChange,
    addPropertyToPlasmaScreens,
    showDeletePropertyFromPlasmaScreenPrompt,
    removePropertyFromPlasmaScreens,
    deletePromptReset,
    updatePropertyPlasmaScreenOrder,
    reorderPropertiesOnPlasmaScreen,
} from '../../redux/reducers/plasmascreens';

import { colors } from '../../shared/styles';

const PlasmaScreensWrapper = styled.div`
    display: flex;
    position: relative;

    .list {
        background: ${colors.white};
        flex-grow: 1;
    }

    .list-wrapper {
        background: ${colors.white};
        height: calc(100vh - 152px);
        overflow: hidden;
    }

    .filter {
        flex: 0 0 300px;
        background: ${colors.grey.default};
        color: ${colors.white};

        .btn {
            display: block;
            background: ${colors.orange.default};
            color: ${colors.white};
            border-radius: 4px;
            text-align: center;
            text-decoration: none;
            padding: 12px 0;
            width: 100%;
            border: 0;
            font-size: 16px;
        }

        .search-section {
            padding: 20px;
            border-bottom: solid 1px ${colors.grey.light};
        }

        h2 {
            margin: 0;
            padding: 20px 30px 20px 30px;
            font-weight: lighter;
            border-bottom: solid 1px ${colors.grey.light};
        }
    }

    .stats {
        display: block;
        text-align: center;
        font-size: 14px;
        font-stretch: normal;
        color: ${colors.darkBlue.default};
    }
`;

class PlasmaScreens extends Component {
    onReset: Function;
    addNewProperty: Function;
    addPromptReset: Function;
    addPromptRefChanged: Function;
    confirmAdd: Function;
    onDelete: Function;
    confirmDelete: Function;
    deletePromptReset: Function;
    onPageChange: Function;
    onReorder: Function;
    onOrderSave: Function;

    constructor(props) {
        super(props);

        this.onReset = this.onReset.bind(this);
        this.addNewProperty = this.addNewProperty.bind(this);
        this.addPromptReset = this.addPromptReset.bind(this);
        this.addPromptRefChanged = this.addPromptRefChanged.bind(this);
        this.confirmAdd = this.confirmAdd.bind(this);
        this.onDelete = this.onDelete.bind(this);
        this.confirmDelete = this.confirmDelete.bind(this);
        this.deletePromptReset = this.deletePromptReset.bind(this);
        this.onPageChange = this.onPageChange.bind(this);
        this.onReorder = this.onReorder.bind(this);
        this.onOrderSave = this.onOrderSave.bind(this);
    }

    componentDidMount() {
        this.props.dispatch(loadPlasmaScreensProperties(1));
    }

    onReset() {
        this.props.dispatch(loadPlasmaScreensProperties(1));
    }

    addPromptReset() {
        this.props.dispatch(addPromptReset());
    }

    addNewProperty() {
        this.props.dispatch(showAddPropertyToPlasmaScreenPrompt());
    }

    addPromptRefChanged(value) {
        this.props.dispatch(addPromptEnteredReferenceChange(value));
    }

    confirmAdd() {
        const { dispatch, addPrompt: { enteredReference } } = this.props;

        dispatch(addPropertyToPlasmaScreens(enteredReference)).then(() => {
            dispatch(loadPlasmaScreensProperties(1));
        });
    }

    onDelete(plasmascreen) {
        this.props.dispatch(
            showDeletePropertyFromPlasmaScreenPrompt(
                plasmascreen.plasmascreenId,
                plasmascreen.plasmascreenPropertyName
            )
        );
    }

    confirmDelete() {
        const {
            dispatch,
            deletePrompt: { plasmascreenId, plasmascreenPropertyName },
        } = this.props;

        dispatch(
            removePropertyFromPlasmaScreens(
                plasmascreenId,
                plasmascreenPropertyName
            )
        ).then(() => {
            dispatch(loadPlasmaScreensProperties(1));
        });
    }

    deletePromptReset() {
        this.props.dispatch(deletePromptReset());
    }

    onPageChange(pageNo) {
        this.props.dispatch(loadPlasmaScreensProperties(pageNo));
    }

    onReorder() {
        this.props.dispatch(reorderPropertiesOnPlasmaScreen());
    }

    onOrderSave(plasmascreens) {
        this.props.dispatch(updatePropertyPlasmaScreenOrder(plasmascreens));
    }

    render() {
        const {
            plasmascreens,
            isFetching,
            addPrompt,
            deletePrompt,
            pagination,
            total,
            fetchingTime,
            reordering,
        } = this.props;

        return (
            <PlasmaScreensWrapper>
                <AddPlasmaPropertyModal
                    isOpen={addPrompt.visible}
                    adding={addPrompt.adding}
                    enteredReference={addPrompt.enteredReference}
                    onCancel={this.addPromptReset}
                    onConfirmAdd={this.confirmAdd}
                    onEnteredReference={this.addPromptRefChanged}
                />
                <DeletePlasmaPropertyModal
                    isOpen={deletePrompt.visible}
                    removing={deletePrompt.removing}
                    plasmascreenPropertyName={
                        deletePrompt.plasmascreenPropertyName
                    }
                    onCancel={this.deletePromptReset}
                    onConfirmDelete={this.confirmDelete}
                />
                <div className="filter">
                    <h2>Plasma Screens</h2>
                    <div className="search-wrapper">
                        <div className="search-section">
                            <button
                                className="btn"
                                type="submit"
                                onClick={this.addNewProperty}
                            >
                                Add New Property
                            </button>
                        </div>
                        <div className="search-section">
                            <span className="stats">
                                {total} result{total !== 1 ? 's' : ''} found in{' '}
                                {fetchingTime}ms
                            </span>
                        </div>
                    </div>
                </div>

                <div className="list">
                    <div className="list-wrapper">
                        {(isFetching || !plasmascreens) &&
                            <Loader message="Loading properties, please wait..." />}

                        {!isFetching &&
                            plasmascreens &&
                            <List
                                plasmascreens={plasmascreens}
                                onDelete={this.onDelete}
                                onOrderSave={this.onOrderSave}
                                onReorder={this.onReorder}
                                reordering={reordering}
                            />}
                    </div>
                    <Pagination
                        onPageChange={this.onPageChange}
                        pagination={pagination}
                    />
                </div>
            </PlasmaScreensWrapper>
        );
    }
}

const mapStateToProps = state => {
    const list = state.plasmascreens.list;
    const add = state.plasmascreens.add;
    const remove = state.plasmascreens.remove;

    return {
        errorFetching: list.error,
        filter: list.filter,
        isFetching: list.fetching,
        addPrompt: {
            enteredReference: add.enteredReference,
            adding: add.adding,
            visible: Boolean(add.visible),
        },
        deletePrompt: {
            plasmascreenId: remove.plasmascreenId,
            plasmascreenPropertyName: remove.plasmascreenPropertyName,
            removing: remove.removing,
            visible: Boolean(
                remove.plasmascreenId && remove.plasmascreenPropertyName
            ),
        },
        plasmascreens: list.plasmascreens,
        pagination: list.pagination,
        total: list.pagination.total,
        fetchingTime: list.fetchingTime,
        reordering: state.plasmascreens.reorder.reordering,
    };
};

export default connect(mapStateToProps)(PlasmaScreens);



// WEBPACK FOOTER //
// ./src/containers/PlasmaScreens/PlasmaScreens.js